import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import CollectionChannelTabs from '@/v2/my-page/collection-channel/collection-channel-tabs/collection-channel-tabs.vue';
import CollectionChannelViews from '@/v2/my-page/collection-channel/collection-channel-views/collection-channel-views.vue';
import type { TAB_CHANNEL } from '@/constants';
import { CHANNEL_DATASOURCE_TYPE, DATA_FILE_TYPE, DISCOVERY_SCRAP_TYPE } from '@/constants';
import CollectionChannelTypesBlog from '@/v2/my-page/collection-channel/collection-channel-types/collection-channel-type-blog/collection-channel-type-blog.vue';
import CollectionChannelTypesCloud from '@/v2/my-page/collection-channel/collection-channel-types/collection-channel-type-cloud/collection-channel-type-cloud.vue';
import CollectionChannelTypesEmail from '@/v2/my-page/collection-channel/collection-channel-types/collection-channel-type-email/collection-channel-type-email.vue';
import CollectionChannelTypesSocial from '@/v2/my-page/collection-channel/collection-channel-types/collection-channel-type-social/collection-channel-type-social.vue';
import CollectionChannelTypesDefault from '@/v2/my-page/collection-channel/collection-channel-types/collection-channel-type-default/collection-channel-type-default.vue';
import ScrapAgentService from '@/service/scrap-agent.service';
import type { AccountChannel, AgentChannel } from '@/shared/model/collection-channel.model';
import ListLoadingComponent from '@/entities/resource-management/list-loading/list-loading.vue';
import ChannelAccountModal from '@/shared/modal/collection-channel/channel-account-modal/channel-account-modal.vue';
import ChannelLoginModal from '@/shared/modal/collection-channel/channel-login-modal/channel-login-modal.vue';
import ChannelModeModal from '@/shared/modal/collection-channel/channel-mode-modal/channel-mode-modal.vue';
import ChannelConfirmModal from '@/shared/modal/collection-channel/channel-confirm-modal/channel-confirm-modal.vue';
import ChannelResultsModal from '@/shared/modal/collection-channel/channel-results-modal/channel-results-modal.vue';
import { ChannelDatasourceProps } from '@/shared/modal/collection-channel/channel-mode-modal/channel-datasource-field/channel-datasource-field.component';
import { AccountResponseDto, ScrapeBriefingRequest } from '@/shared/model/scrap-agent.model';
import { isEmptyArray } from '@/util/array-util';
import GoPagination from '@/core/go-pagination/go-pagination.vue';

type SOURCE_CHANNEL_TYPE = typeof DISCOVERY_SCRAP_TYPE[keyof typeof DISCOVERY_SCRAP_TYPE];

@Component({
  computed: {
    DISCOVERY_SCRAP_TYPE() {
      return DISCOVERY_SCRAP_TYPE;
    },
  },
  methods: {},
  components: {
    'channel-confirm-modal': ChannelConfirmModal,
    'channel-results-modal': ChannelResultsModal,
    'channel-account-modal': ChannelAccountModal,
    'channel-login-modal': ChannelLoginModal,
    'channel-mode-modal': ChannelModeModal,
    'go-loading': ListLoadingComponent,
    'go-pagination': GoPagination,
    'collection-channel-tabs': CollectionChannelTabs,
    'collection-channel-views': CollectionChannelViews,
    'collection-channel-type-blog': CollectionChannelTypesBlog,
    'collection-channel-type-cloud': CollectionChannelTypesCloud,
    'collection-channel-type-email': CollectionChannelTypesEmail,
    'collection-channel-type-social': CollectionChannelTypesSocial,
    'collection-channel-type-default': CollectionChannelTypesDefault,
  },
})
export default class CollectionChannel extends Vue {
  @Inject('scrapAgentService')
  public scrapAgentService: () => ScrapAgentService;

  state = {
    tabSelected: 'ALL' as TAB_CHANNEL,
    accountChannels: [] as AccountChannel[],
    loading: false,
    changeAccountSelected: null as AccountChannel | null,
    unlinkAccountSelected: null as AccountChannel | null,
    stats: [],
    pagination: {
      currentPage: 1,
      totalPages: 0,
      pageSize: 5,
    },
    channelModifyConfirmModal: {
      open: false,
      agentChannels: [],
    },
    channelDeleteConfirmModal: {
      open: false,
      agentChannels: [],
    },
    channelAccessResultsModal: {
      open: false,
      title: null,
      description: null,
      type: null as 'SUCCESS' | 'ERROR' | null,
    },
    channelAccountModal: {
      open: false,
      accounts: [] as AccountResponseDto[],
      loading: false,
      channelImageUri: null,
      channelName: null,
      channelType: null,
    },
    channelLoginModal: {
      open: false,
      channelType: null,
    },
    channelModeModal: {
      open: false,
      accountChannel: null as AccountChannel | null,
      agentChannel: null as AgentChannel | null,
      datasource: [],
      channelImageUri: null,
      channelName: null,
      channelType: null,
    },
  };
  apiParams = {
    dataSourceChannel: DISCOVERY_SCRAP_TYPE.ALL as Array<string> | null,
    keyword: '',
  };

  get totalItems() {
    if (!this.apiParams.dataSourceChannel) return this.state.stats.reduce((acc, cur) => acc + cur.count, 0);
    return this.state.stats
      .filter(stat => this.apiParams.dataSourceChannel.includes(stat.channelType))
      .reduce((acc, cur) => acc + cur.count, 0);
  }

  mounted() {
    this.fetchCollectionChannels();
    this.countAllChannel();
  }

  deactivated() {
    this.onChangeAccountClose();
    this.onAccessResultsClose();
    this.onChangeAccountConfirmClose();
    this.onUnlinkAccountConfirmClose();
    this.onRegisterAccountClose();
    this.onUpdateAgentClose();
  }

  onChangeTabs = (tab: TAB_CHANNEL, sourceChannelTypes: SOURCE_CHANNEL_TYPE): void => {
    if (this.state.tabSelected != tab) {
      this.onChangeSourceChannels(sourceChannelTypes);
    }
    this.state.tabSelected = tab;
  };

  onChangeSourceChannels = (sourceChannelTypes: SOURCE_CHANNEL_TYPE): void => {
    this.apiParams.dataSourceChannel = sourceChannelTypes;
  };

  roueToMyPage() {
    this.$router.push('/my-page');
  }

  fetchCollectionChannels() {
    const userKey = JSON.parse(localStorage.getItem('localStorageUser')).id;
    if (userKey) {
      this.state.loading = true;
      this.scrapAgentService()
        .getAllChannelByChannel(
          userKey,
          this.apiParams.dataSourceChannel,
          this.state.pagination.currentPage - 1,
          this.state.pagination.pageSize
        )
        .then(res => {
          if (res.data.success) {
            this.state.accountChannels = res.data.body.data;
          }
        })
        .finally(() => {
          this.state.loading = false;
        });
    }
  }

  countAllChannel() {
    const userKey = JSON.parse(localStorage.getItem('localStorageUser')).id;
    console.log(userKey);
    if (userKey) {
      this.scrapAgentService()
        .countAllChannel(userKey)
        .then(res => {
          if (res.data.success) {
            this.state.stats = res.data.body;
          }
        });
    }
  }

  @Watch('apiParams', { deep: true })
  onApiParamsChange() {
    this.state.pagination.currentPage = 1;
    this.fetchCollectionChannels();
  }

  onPageChange(page: number) {
    this.state.pagination.currentPage = page;
    this.fetchCollectionChannels();
  }

  onRegisterAccount(channelType: string) {
    this.state.channelLoginModal = {
      open: true,
      channelType: channelType,
    };
  }

  onRegisterAccountClose() {
    this.state.channelLoginModal = {
      ...this.state.channelLoginModal,
      open: false,
    };
  }

  async handleRegisterAccount(account: any) {
    this.state.channelLoginModal = {
      open: false,
      channelType: null,
    };
    this.state.channelAccountModal = {
      ...this.state.channelAccountModal,
      loading: true,
    };
    const accounts = await this.fetchAccountInChannels(this.state.channelAccountModal.channelType);
    this.state.channelAccountModal = {
      ...this.state.channelAccountModal,
      loading: false,
      accounts,
    };
  }

  onChangeAccountConfirm(acc: AccountChannel) {
    this.state.changeAccountSelected = acc;
    this.state.channelModifyConfirmModal = {
      open: true,
      agentChannels: acc.collections,
    };
  }

  onChangeAccountConfirmClose() {
    this.state.channelModifyConfirmModal = {
      ...this.state.channelModifyConfirmModal,
      open: false,
    };
  }

  async onChangeAccount() {
    this.onChangeAccountConfirmClose();
    this.state.channelAccountModal = {
      open: true,
      loading: true,
      accounts: [],
      channelType: this.state.changeAccountSelected.channelType,
      channelName: this.state.changeAccountSelected.channelNameEn,
      channelImageUri: this.state.changeAccountSelected.channelImageUri,
    };
    const accounts = await this.fetchAccountInChannels(this.state.changeAccountSelected.channelType);
    this.state.channelAccountModal = {
      ...this.state.channelAccountModal,
      loading: false,
      accounts,
    };
  }

  onChangeAccountClose() {
    this.state.channelAccountModal = {
      ...this.state.channelAccountModal,
      open: false,
    };
  }

  handleChangeAccount(acc: AccountResponseDto) {
    const payload = {
      ...this.state.changeAccountSelected,
      accountId: acc.accountId.toString(),
    } as AccountChannel;
    this.scrapAgentService()
      .updateAccount(payload)
      .then(res => {
        this.onChangeAccountClose();
        this.state.channelAccessResultsModal = {
          open: true,
          type: 'SUCCESS',
          title: this.$t('my-collection-channel.modal.results.change-account.success.title'),
          description: this.$t('my-collection-channel.modal.results.change-account.success.description'),
        };
        console.log(res);
      });
  }

  fetchAccountInChannels = async (channelType: string) => {
    const res = await this.scrapAgentService().getUserScrapAgent({
      requestId: new Date().getTime().toString(),
      userKey: this.$store.getters.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id,
      chanelName: channelType,
    });
    if (res.data.success) {
      return res.data.body;
    }
    return [];
  };

  onUnlinkAccountConfirm(acc: AccountChannel) {
    this.state.unlinkAccountSelected = acc;
    this.state.channelDeleteConfirmModal = {
      open: true,
      agentChannels: acc.collections,
    };
  }

  onUnlinkAccountConfirmClose() {
    this.state.channelDeleteConfirmModal = {
      ...this.state.channelDeleteConfirmModal,
      open: false,
    };
  }

  handleUnlinkAccount() {
    this.onUnlinkAccountConfirmClose();
    this.scrapAgentService()
      .unlinkAccount(this.state.unlinkAccountSelected)
      .then(res => {
        this.state.channelAccessResultsModal = {
          open: true,
          type: 'SUCCESS',
          title: this.$t('my-collection-channel.modal.results.unlink-account.success.title'),
          description: this.$t('my-collection-channel.modal.results.unlink-account.success.description'),
        };
      });
  }

  onAccessResultsClose() {
    this.state.channelAccessResultsModal = {
      ...this.state.channelAccessResultsModal,
      open: false,
    };
  }

  onUpdateAgent(acc: AccountChannel, agent: AgentChannel) {
    const datasource = [] as ChannelDatasourceProps[];
    const datasourceTypes = CHANNEL_DATASOURCE_TYPE[acc.channelType];
    datasourceTypes.forEach(datasourceType => {
      switch (datasourceType.type) {
        case 'DATA_TYPE': {
          const datasourceEverything = agent.datasourceList.find(el => el.dataSourceType === 'EVERY_THING');
          const dataFileTypes = DATA_FILE_TYPE.map(type => type.value);
          datasource.push({
            type: datasourceType.type,
            multiple: datasourceType.multiple,
            value: agent.datasourceList.filter(el => dataFileTypes.includes(el.dataSourceType)).map(el => el.dataSourceType),
            disabled: !!datasourceEverything?.dataSourceAccStatus,
          });
          break;
        }
        case 'MY_SUBSCRIPTION':
        case 'MY_CHANNEL':
        case 'MY_PROFILE': {
          if (!acc.accountId) break;
          const datasourceItem = agent.datasourceList.find(el => el.dataSourceType === datasourceType.type);
          datasource.push({
            agentId: datasourceItem ? datasourceItem.agentId : undefined,
            dataSourceId: datasourceItem ? datasourceItem.dataSourceId : undefined,
            type: datasourceType.type,
            multiple: datasourceType.multiple,
            value: !!datasourceItem?.dataSourceAccStatus,
          });
          break;
        }
        case 'TRENDING':
        case 'INBOX':
        case 'EVERY_THING':
        case 'NEW_FEED': {
          const datasourceItem = agent.datasourceList.find(el => el.dataSourceType === datasourceType.type);
          datasource.push({
            agentId: datasourceItem ? datasourceItem.agentId : undefined,
            dataSourceId: datasourceItem ? datasourceItem.dataSourceId : undefined,
            type: datasourceType.type,
            multiple: datasourceType.multiple,
            value: !!datasourceItem?.dataSourceAccStatus,
          });
          break;
        }
        case 'PROFILE':
        case 'KEYWORD':
        case 'URL':
        case 'TOPIC': {
          const datasourceItems = agent.datasourceList.filter(el => el.dataSourceType === datasourceType.type);
          if (!datasourceItems || !datasourceItems.length) {
            datasource.push({
              type: datasourceType.type,
              multiple: datasourceType.multiple,
              value: [''],
            });
            break;
          }
          datasource.push(
            ...datasourceItems.map(datasourceItem => ({
              agentId: datasourceItem.agentId,
              dataSourceId: datasourceItem.dataSourceId,
              type: datasourceType.type,
              multiple: datasourceType.multiple,
              value: datasourceItem.datasourceValue ? JSON.parse(datasourceItem.datasourceValue) : [''],
            }))
          );
          break;
        }
      }
    });
    this.state.channelModeModal = {
      open: true,
      channelType: acc.channelType,
      channelName: acc.channelNameEn,
      channelImageUri: acc.channelImageUri,
      accountChannel: acc,
      agentChannel: agent,
      datasource,
    };
  }

  onUpdateAgentClose() {
    this.state.channelModeModal = {
      ...this.state.channelModeModal,
      open: false,
    };
  }

  handleUpdateAgent(datasource: ChannelDatasourceProps[]) {
    const payload: ScrapeBriefingRequest = {
      requestId: new Date().getTime(),
      userKey: this.$store.getters.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id,
      bpId: this.state.channelModeModal.agentChannel?.bpId,
      dataSourceAccount: [
        {
          accountId: this.state.channelModeModal.accountChannel?.accountId,
          channelType: this.state.channelModeModal.accountChannel?.channelType,
          isScrap: this.state.channelModeModal.agentChannel.isScrap,
          dataSources: datasource.reduce((acc, cur) => {
            if (cur.disabled) return acc;
            switch (cur.type) {
              case 'DATA_TYPE': {
                acc.push(
                  ...cur.value.map(type => {
                    const datasourceItem = this.state.channelModeModal.agentChannel?.datasourceList?.find(el => el.dataSourceType === type);
                    return {
                      agentId: datasourceItem ? datasourceItem.agentId : undefined,
                      dataSourceId: datasourceItem ? datasourceItem.dataSourceId : undefined,
                      dataSourceTypes: [type],
                      dataSourceType: type,
                    };
                  })
                );
                return acc;
              }
              case 'TRENDING':
              case 'MY_SUBSCRIPTION':
              case 'MY_CHANNEL':
              case 'INBOX':
              case 'EVERY_THING':
              case 'MY_PROFILE':
              case 'NEW_FEED': {
                if (cur.value) {
                  acc.push({
                    agentId: cur.agentId,
                    dataSourceId: cur.dataSourceId,
                    dataSourceTypes: [cur.type],
                    dataSourceType: cur.type,
                  });
                }
                return acc;
              }
              case 'PROFILE':
              case 'KEYWORD':
              case 'URL':
              case 'TOPIC': {
                if (!isEmptyArray(cur.value) && cur.value.every((el: string) => el.trim())) {
                  acc.push({
                    agentId: cur.agentId,
                    dataSourceId: cur.dataSourceId,
                    dataSourceTypes: [cur.type],
                    dataSourceType: cur.type,
                    value: cur.value.filter((el: string) => el.trim()),
                  });
                }
                return acc;
              }
            }
          }, []),
        },
      ],
    };
    this.scrapAgentService()
      .updateScrapAgent(payload)
      .then(res => {
        if (res.data?.body?.success) {
          this.fetchCollectionChannels();
          this.state.channelModeModal = {
            ...this.state.channelModeModal,
            open: false,
          };
          this.state.channelAccessResultsModal = {
            open: true,
            type: 'SUCCESS',
            title: this.$t('my-collection-channel.modal.results.change-account.success.title'),
            description: this.$t('my-collection-channel.modal.results.change-account.success.description'),
          };
        }
      });
  }
}
